<div class="container-fluid d-flex flex-column h-100">
  <div
    class="row row-padding-top-lg justify-content-between align-items-center"
  >
    <div class="col-auto">
      <h2 class="title bold">{{ title }}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col"></div>
    <div class="col-4 d-flex flex-column align-items-end">
      <div class="form-check">
        <label for="showArchived" class="form-check-label m-0"
          >Show archived?</label
        >
        <input
          id="showArchived"
          type="checkbox"
          class="form-check-input"
          [checked]="showArchived"
          (change)="onShowArchivedChange()"
        />
      </div>
    </div>
  </div>
  <div class="row pb-3 flex-grow-1">
    @if (initialized) {
      <app-company-vendors-grid
        [gridName]="'Compliance'"
        [Filters]="Filters"
        [suppliedQueryData]="suppliedQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [getCalculatedColumnActions]="calculatedColumnActions"
        (actionEvent)="actionEvent($event)"
        [(reloadGridData)]="reloadGrid"
      ></app-company-vendors-grid>
    }
  </div>
</div>
